import '../../App.css';
import { useEffect } from 'react';
import React, { useState, useRef } from "react";
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import YouTubePlayer from '../../components/VideoPlayer/videoPlayer';
import "./UNOR4.css";
import {useNavigate} from "react-router-dom";

const UNOR4 = () => {

    const [isVisible, setIsVisible] = useState(false);
    const containerRef = useRef(null);
    const [stage, setStage] = useState(1);
    const [showFinalImage, setShowFinalImage] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animationFinished, setAnimationFinished] = useState(false);

    const navigate = useNavigate()

    const handleComprar = () => {
        navigate("/products/137-Arduino%20UNO%20R4%20WIFI")
    }

    const images = [
        "/images/R4/One.png",
        "/images/R4/Two.png",
        "/images/R4/Three.png",
        "/images/R4/Four.png",
        "/images/R4/Five.png",
        "/images/R4/Six.png",
    ];
    useEffect(() => {
        if (currentIndex < images.length) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => prevIndex + 1);
            }, 150);

            return () => clearInterval(interval);
        } else {
            setAnimationFinished(true);
        }
    }, [currentIndex, images.length]);

    return (
        <div>
            <Header/>
            <div className="image-rotation-container">
                <img
                    src={images[Math.min(currentIndex, images.length - 1)]}
                    alt="Rotating Animation Frame"
                    className="animation-image"
                />
                <h1 className="title">{animationFinished ? "UNO R4 WIFI" : "\u00A0"}</h1>
                <h2> {animationFinished ? "Tu placa favorita, evolucionada" : "\u00A0"} </h2>
                {animationFinished ? <button className="order-btn" onClick={handleComprar}> Compra Ahora</button> : "\u00A0"}
                <br/>

            </div>

            <YouTubePlayer videoUrl="https://www.youtube.com/watch?v=TFAPjtsuSTg"/>

            <div className="UNO-info-container">
                <h1 className="UNO-title">¡La placa de microcontrolador más <br/>divertida y fácil de usar</h1>
                <div className="UNO-content">
                    <div className="UNO-image-container">
                        <img src={'/images/R4_2.png'} alt="Microcontrolador ESP32" className="UNO-image"/>
                        <div className="UNO-dots-overlay"></div>
                    </div>
                    <div className="UNO-text-container">
                        <div className="UNO-text UNO-text-1">
                            Matriz led 12x18
                        </div>
                        <div className="UNO-text UNO-text-2">
                            Conexión Wifi y Bluetooth
                        </div>
                        <div className="UNO-text UNO-text-3">
                            Soporte completo en Arduino IDE
                        </div>
                        <div className="UNO-text UNO-text-4">
                            DAC y ADC integrados
                        </div>

                        <div className="UNO-text UNO-text-5">
                            16 veces más SRAM que el UNO R3
                        </div>
                    </div>
                </div>
            </div>
            <div className="technical-specs-container">
                <div className="technical-specs-box">
                    <div>
                        <h2 className="technical-specs-title">Especificaciones técnicas:</h2>
                        <ul className="technical-specs-list">
                            <li>14 Pines Digitales PWM</li>
                            <li>SRAM 32kB</li>
                            <li>Memoria Flash 256kB</li>
                            <li>USB C</li>
                            <li>Bluetooth 5</li>
                            <li>Wi-Fi 4</li>
                        </ul>
                    </div>
                </div>
                <img
                    src="/images/R4Caja.jpg"
                    alt="Descripción de la imagen"
                    className="technical-specs-image"
                />
            </div>


            <div className="ESP-info-container">
                <h1 className="ESP-title">
                    Retrocompatible con UNO R3
                </h1>
                <div className="image-rotation-container">

                    <button className="order-btn" onClick={handleComprar}> Compra Ahora</button>

                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default UNOR4;